import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { FutureStock } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class FutureStockRepository extends RepositoryBase<FutureStock> {
  protected readonly KEY_PATH = 'future_stock';
}
